import { WidgetConfig } from '@helo/cms'
import { ReactNode, createContext, useContext } from 'react'

import { WidgetMeta } from '../widget-types'

export const widgetContext = createContext<WidgetConfig>(
  {} as unknown as WidgetConfig,
)

export interface WidgetProviderProps {
  value: WidgetConfig
  children?: ReactNode
}

export const WidgetProvider = ({ children, value }: WidgetProviderProps) => (
  <widgetContext.Provider value={value}>{children}</widgetContext.Provider>
)

export const useWidgetConfig = () => useContext(widgetContext)
